import { render, staticRenderFns } from "./OrkDialog.vue?vue&type=template&id=0c28ca68&"
import script from "./OrkDialog.vue?vue&type=script&lang=js&"
export * from "./OrkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports